import { Row, Col, Card, Button, Pagination, Form } from "react-bootstrap";
import {
  useGetProductsQuery
} from "../slices/productsApiSlice";
import { useGetStocksQuery } from "../slices/stocksApiSlice";
import { useGetSalesQuery } from "../slices/salesApiSlice";
import { useGetTransfersQuery } from "../slices/transfersApiSlice";
import { useGetSuppliesQuery } from "../slices/suppliesApiSlice";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Meta from "../components/Meta";
import { useDispatch } from "react-redux";
import { addToCart } from "../slices/cartSlice";
import { useState, useEffect } from "react";

const HomeScreen = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;


  const { data, isLoading, error } = useGetProductsQuery({
    keyword: searchTerm,
    pageNumber,
  });

  const { data: stocksData } = useGetStocksQuery();
  const { data: salesData } = useGetSalesQuery();
  const { data: suppliesData } = useGetSuppliesQuery();
  const { data: transfersData } = useGetTransfersQuery();

  const [qtys, setQtys] = useState({});
  const [stockBalances, setStockBalances] = useState({});

  const handleQtyChange = (productId, value) => {
    setQtys({ ...qtys, [productId]: value });
  };

  const addToCartHandler = (product) => {
    const qty = qtys[product._id] || 0;
    dispatch(addToCart({ ...product, qty }));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (
      !stocksData?.stocks ||
      !salesData?.sales ||
      !suppliesData?.supplies ||
      !transfersData?.transfers
    )
      return;

    const firstDate = stocksData.stocks
      .map((item) => new Date(item.date))
      .reduce(
        (minDate, currentDate) =>
          currentDate < minDate ? currentDate : minDate,
        new Date()
      )
      .toISOString()
      .split("T")[0];

    const secondDate = new Date().toISOString().split("T")[0];

    const calculateMetrics = (product, type) => {
      const dataMap = {
        sales: salesData?.sales,
        supplies: suppliesData?.supplies,
        transfers: transfersData?.transfers,
      };

      const itemKeyMap = {
        sales: "saleItems",
        supplies: "supplyItems",
        transfers: "transferItems",
      };

      const records =
        dataMap[type]?.flatMap(
          (item) =>
            item[itemKeyMap[type]]?.filter(
              (subItem) =>
                subItem.name === product.name &&
                new Date(item.date) >= new Date(firstDate) &&
                new Date(item.date) <= new Date(secondDate)
            ) || []
        ) || [];

      return records.reduce(
        (total, record) => total + Number(record.qty || 0),
        0
      );
    };

    const getInitialStock = (product) =>
      stocksData?.stocks
        .flatMap(
          (item) =>
            item.stockItems?.filter(
              (subItem) =>
                subItem.name === product.name &&
                new Date(item.date) <= new Date(firstDate)
            ) || []
        )
        .reduce((total, subItem) => total + Number(subItem.qty || 0), 0);

    const stockBalancesTemp = {};
    data?.products?.forEach((product) => {
      const initialStock = getInitialStock(product);
      const purchases = calculateMetrics(product, "supplies");
      const salesQty = calculateMetrics(product, "sales");
      const transfersQty = calculateMetrics(product, "transfers");
      const closingStock = initialStock + purchases - salesQty - transfersQty;

      stockBalancesTemp[product._id] = closingStock;
    });

    setStockBalances(stockBalancesTemp);
  }, [stocksData, salesData, suppliesData, transfersData, data]);

  const filteredProducts = data?.products?.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginationHandler = (page) => {
    setPageNumber(page);
  };

  const getStockBadge = (qty) => {
  if (qty <= 0) return { text: "Out of Stock", color: "red" };
  if (qty <= 10) return { text: "Low Stock", color: "orange" };
  return { text: "In Stock", color: "green" };
};

const startVoiceSearch = () => {
  if (!SpeechRecognition) {
    alert("Voice recognition not supported in this browser.");
    return;
  }

  const recognition = new SpeechRecognition();
  recognition.lang = "en-US";
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;

  recognition.start();

  recognition.onresult = (event) => {
    const voiceText = event.results[0][0].transcript;
    setSearchTerm(voiceText);   // Put spoken text into search box
  };

  recognition.onerror = (event) => {
    console.error("Speech recognition error:", event.error);
  };
};


  return (
    <div className={darkMode ? "bg-dark text-light p-3" : "p-3"}>
      <Meta />

      {/* DARK MODE TOGGLE */}
      <Form.Check
        type="switch"
        id="dark-mode-switch"
        label="Dark Mode"
        checked={darkMode}
        onChange={() => setDarkMode(!darkMode)}
        className="mb-3"
      />

      {searchTerm && (
        <Link to="/" className="btn btn-light mb-4">
          Go Back
        </Link>
      )}

     <div className="mb-4 text-center">
     <div style={{ maxWidth: "400px", margin: "0 auto" }}>
    <input
      type="text"
      placeholder="Search products..."
      className="form-control"
      value={searchTerm}
      onChange={handleSearch}
      style={{
        backgroundColor: darkMode ? "#333" : "white",
        color: darkMode ? "white" : "black",
      }}
    />

    {/* Voice Search Button */}
    <Button
  variant="info"
  className="mt-2"
  onClick={startVoiceSearch}
  style={{
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    padding: "0",
    fontSize: "18px",
    lineHeight: "36px",
  }}
>
  🎤
</Button>

    

  </div>
</div>


      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          <h1>Products</h1>
          <Row>
            {filteredProducts?.map((product) => {
              const stockQty = stockBalances[product._id] || 0;
              const badge = getStockBadge(stockQty);

              return (
                <Col key={product._id} xs={12} sm={6} md={6} lg={3}>
                  <Card
                    className={`mb-4 shadow-sm ${
                      darkMode ? "bg-secondary text-light" : ""
                    }`}
                  >
                    {product.images?.length > 0 && (
                      <Card.Img
                        variant="top"
                        src={product.images[0]}
                        alt={product.name}
                        style={{
                          width: "75%",
                          height: "150px",
                          objectFit: "cover",
                          borderRadius: "10px",
                        }}
                      />
                    )}

                    <Card.Body>
                      <Card.Title>{product.name}</Card.Title>
                       
                      <span
                      style={{
                        padding: "4px 8px",
                        borderRadius: "6px",
                        backgroundColor: badge.color,
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {badge.text}
                    </span>
                    <Card.Text className="mt-2">
                     Balance: {stockBalances[product._id] ?? 'Calculating...'}
                     </Card.Text>

                      <Card.Text className="mt-2">
                        Price: D{product.price}
                      </Card.Text>

                      <Card.Text>Type: {product.brand}</Card.Text>

                      {/* Quantity Input */}
                      <Form.Control
                        type="number"
                        min="0"
                        max={product.countInStock}
                        value={qtys[product._id] || 0}
                        onChange={(e) => {
                          const newQty = Number(e.target.value);
                          if (
                            newQty >= 0 &&
                            newQty <= product.countInStock
                          ) {
                            handleQtyChange(product._id, newQty);
                          }
                        }}
                        style={{
                          width: "80px",
                          textAlign: "center",
                          marginBottom: "10px",
                          backgroundColor: darkMode ? "#333" : "white",
                          color: darkMode ? "white" : "black",
                        }}
                      />

                      <Button
                        variant="warning"
                        className="btn-sm"
                        onClick={() => addToCartHandler(product)}
                        disabled={
                          (qtys[product._id] || 0) === 0 ||
                          product.countInStock === 0
                        }
                      >
                        Add To Cart
                      </Button>

                      <Link
                        className="btn btn-primary btn-sm m-2"
                        to={`/product/${product._id}`}
                      >
                        Details
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          <Pagination>
            {[...Array(data.pages).keys()].map((x) => (
              <Pagination.Item
                key={x + 1}
                active={x + 1 === pageNumber}
                onClick={() => paginationHandler(x + 1)}
              >
                {x + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      )}
    </div>
  );
};

export default HomeScreen;
